// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .sidebar-collapse-button {
	right: 5px;
	top: 0;
	text-align: center;
	position: absolute;
	padding: 0;
	z-index: 9999;
	border-radius: 0;
	width: 20px;
	height: 15px;

	a {
		width: 24px;
		height: 24px;
		position: absolute;
		border-radius: 24px;
		color: inherit !important;
		top: 50%;
		margin-top: -12px;
		right: -12px;
		display: inline-flex;
		align-items: center;
	}
	svg {
		margin: 0 auto;
		display: block;
	}
} */
.sidebar-dragicon {
  cursor: move !important;
}

.sidebar-thumbs-icon {
  font-size: 14px;
}

.trackYVisible .ScrollbarsCustom-TrackY {
  background: none !important;
}
.trackYVisible .ScrollbarsCustom-ThumbY {
  background: rgba(0, 0, 0, 0.5) !important;
}
.trackYVisible:hover .ScrollbarsCustom-ThumbY {
  display: block;
}
.trackYVisible:hover .ScrollbarsCustom-ThumbY:hover {
  background: rgb(0, 0, 0) !important;
}
.trackYVisible .ScrollbarsCustom-ThumbY {
  display: none;
}

.main-navigation .trackYVisible .ScrollbarsCustom-Track, .main-navigation .trackXVisible .ScrollbarsCustom-Track {
  display: none;
}
.main-navigation .ScrollbarsCustom-Wrapper {
  inset: 0 !important;
}

.sidebar-devices-list {
  height: calc(100vh - 46px - 27px);
}

.geofence-sidebar-list,
.sidebar-drivers-list,
.sidebar-users-list,
.sidebar-devices-list.with-tabs {
  height: calc(100vh - 66px - 54px - 60px);
}

/* .calendar-sidebar-list {
	overflow: hidden;
	overflow-y: scroll;
}
 */
.notification-scroller {
  height: calc(100vh - 10px);
  overflow-y: scroll;
}

/* .scrollable-sidebar {
	height: calc(100vh );
} */
.action-item.online {
  color: "#fffff";
}

.action-item.offline {
  color: "#fff45";
}

.action-item.unknown {
  color: "#f8989f";
}

.action-item.not-updated {
  color: #0288d1;
}

.action-item.not-registered {
  color: #d7d7d7;
}

.main-content-page {
  margin-left: 60px;
  transition: 0.3s ease;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.15);
}

.left-nav {
  transition: 0.3s ease;
}

.sidebar-bg-layer {
  border-radius: 6px;
}

.fms-sidebar .list-row-condest .list-view-group > li > .list-row:first-child:before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 26px;
  vertical-align: top;
  border-radius: 0 5px 5px 0;
}

.main-list-view .fms-sidebar .list-row-condest .list-view-group > li > .list-row:first-child:before {
  display: none;
}

.main-thumb-view .fms-sidebar .list-view-children .v-checkbox.on-inactive {
  display: none;
}
.main-thumb-view .fms-sidebar .list-view-children .v-checkbox.on-active {
  border-radius: 50px;
  border: 0;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
}
.main-thumb-view .fms-sidebar .list-view, .main-thumb-view .fms-sidebar .list-view-group > li {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 10px 0;
}
.main-thumb-view .fms-sidebar .list-view .list-view, .main-thumb-view .fms-sidebar .list-view-group > li .list-view, .main-thumb-view .fms-sidebar .list-view .list-view-group > li, .main-thumb-view .fms-sidebar .list-view-group > li .list-view-group > li {
  padding-left: 0;
  padding-right: 0;
}
.main-thumb-view .fms-sidebar .list-view .list-row, .main-thumb-view .fms-sidebar .list-view-group > li .list-row {
  border-radius: 6px;
  height: 100%;
}
.main-thumb-view .fms-sidebar .list-view .list-row .pull-right, .main-thumb-view .fms-sidebar .list-view-group > li .list-row .pull-right {
  float: none !important;
  text-align: center;
  line-height: 16px;
  height: 16px;
}
.main-thumb-view .fms-sidebar .list-view .checkbox, .main-thumb-view .fms-sidebar .list-view-group > li .checkbox {
  position: absolute;
  right: -2px;
  bottom: -4px;
  z-index: 9;
}
.main-thumb-view .fms-sidebar .list-view .action-item, .main-thumb-view .fms-sidebar .list-view-group > li .action-item,
.main-thumb-view .fms-sidebar .list-view .action-item.action-running {
  margin-top: 0;
}
.main-thumb-view .fms-sidebar .list-view .action-connection, .main-thumb-view .fms-sidebar .list-view-group > li .action-connection {
  float: none;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.main-thumb-view .fms-sidebar .list-view .action-connection .circle, .main-thumb-view .fms-sidebar .list-view-group > li .action-connection .circle {
  margin-left: auto;
  margin-right: auto;
}
.main-thumb-view .fms-sidebar .action-running.online {
  color: inherit;
}
.main-thumb-view .fms-sidebar {
  /* .list-row-condest .list-view .action-item,
  .list-row-condest .list-view-group > li .action-item,
  .list-row-condest .list-view-group > li .action-item {
  	line-height: 10px;
  } */
}
.main-thumb-view .fms-sidebar .list-view > li, .main-thumb-view .fms-sidebar .list-view-group > li > li {
  display: inline-block;
  width: 93px;
  position: relative;
  padding-left: 4px;
  padding-bottom: 4px;
  flex: 0 0 33.3333%;
}
.main-thumb-view .fms-sidebar .list-view > li .list-action-bar, .main-thumb-view .fms-sidebar .list-view-group > li > li .list-action-bar {
  height: auto;
  display: block;
  padding-top: 0;
  line-height: 4px;
}
.main-thumb-view .fms-sidebar .list-view > li .unit-name, .main-thumb-view .fms-sidebar .list-view-group > li > li .unit-name {
  min-width: calc(100% - 20px);
  margin: 15px 10px 0;
  max-width: inherit;
  text-align: center;
  display: block;
}
.main-thumb-view .fms-sidebar .unit-name img {
  width: 42px;
  height: 42px;
  max-width: none;
  display: block;
  margin: 0 auto;
}
.main-thumb-view .fms-sidebar .action-connection {
  display: block;
}
.main-thumb-view .fms-sidebar .action-connection a {
  display: block;
}
.main-thumb-view .fms-sidebar .circle {
  width: 46px;
  border-radius: 0;
  border-width: 1.5px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.main-thumb-view .fms-sidebar .action-running,
.main-thumb-view .fms-sidebar .action-view {
  position: absolute;
  left: 32px;
  top: 5px;
}
.main-thumb-view .fms-sidebar .action-running {
  left: 10px;
}
.main-thumb-view .fms-sidebar .action-ellipsis {
  right: 0;
  position: absolute;
  top: 5px;
}
.main-thumb-view .fms-sidebar .group-view .list-view, .main-thumb-view .fms-sidebar .group-view .list-view-group > li {
  width: 100%;
}
.main-thumb-view .fms-sidebar .group-view .list-view-group > li .list-view .list-row, .main-thumb-view .fms-sidebar .group-view .list-view-group > li .list-view-group > li .list-row {
  padding-left: 5px;
}
.main-thumb-view .fms-sidebar .group-view .list-view-group > li .list-view .list-row .unit-name, .main-thumb-view .fms-sidebar .group-view .list-view-group > li .list-view-group > li .list-row .unit-name {
  min-width: inherit;
}
.main-thumb-view .fms-sidebar .group-view .list-view-group > li .list-view .list-row .pull-right, .main-thumb-view .fms-sidebar .group-view .list-view-group > li .list-view-group > li .list-row .pull-right {
  text-align: center;
}
.main-thumb-view .fms-sidebar .list-view-group {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}
.main-thumb-view .fms-sidebar .list-view-group > li {
  width: 100%;
}
.main-thumb-view .fms-sidebar .list-view-group > li > div {
  width: 100%;
}
.main-thumb-view .fms-sidebar .list-view-group > li > .list-row:first-child {
  width: 100%;
  border-radius: 0;
}
.main-thumb-view .fms-sidebar .list-view-group > li > .list-row:first-child > .checkbox {
  position: static;
}
.main-thumb-view .fms-sidebar .list-view-group > li > .list-row:first-child .pull-right {
  float: right !important;
  text-align: center;
}
.main-thumb-view .fms-sidebar .list-view-group > li > .list-row:first-child .unit-name {
  display: inline-block;
  text-align: left;
  margin: 0 0 0 10px;
}

.filter-row {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: table;
  width: 100%;
}
.filter-row > li {
  display: table-cell;
  vertical-align: middle;
  white-space: nowrap;
  padding: 0 6px;
  line-height: 26px;
}
.filter-row .btn-group {
  margin-left: 10px;
}
.filter-row > li > a {
  padding-left: 2px;
  padding-right: 2px;
  color: inherit;
  vertical-align: bottom;
  line-height: 26px;
}
.filter-row > li > a svg {
  vertical-align: top;
  margin-top: 3px;
}
.filter-row > li > a i {
  line-height: inherit;
}
.filter-row .checkbox input + span {
  height: 26px;
}
.filter-row .filter-nav {
  font-size: 12px;
  display: table;
  width: 100%;
  height: 32px;
  position: relative;
}
.filter-row .filter-nav .add-group-link {
  vertical-align: middle;
}
.filter-row .filter-nav .add-group-link i {
  vertical-align: middle;
}
.filter-row .filter-nav-link {
  display: table-cell;
  width: 1%;
  border-radius: 6px 6px 0 0;
  vertical-align: middle;
  font-size: inherit;
  text-decoration: none;
  font-weight: bold;
  text-align: center;
}

.fms-sidebar {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.fms-sidebar .section-head {
  padding: 5px 10px;
  margin-bottom: 3px;
}
.fms-sidebar .section-head-filter {
  padding: 5px;
}
.fms-sidebar .v-divider {
  display: inline-block;
  vertical-align: top;
  margin-left: 8px;
  margin-right: 8px;
  height: 21px;
}
.fms-sidebar {
  /* .individual-view {
  } */
}
.fms-sidebar .group-view .list-view-children {
  padding: 0;
}
.fms-sidebar .list-view, .fms-sidebar .list-view-group > li {
  margin: 0;
  padding: 0 10px;
  list-style: none;
  font-weight: normal;
}
.fms-sidebar .list-view .checkbox input + span i, .fms-sidebar .list-view-group > li .checkbox input + span i {
  line-height: inherit;
}
.fms-sidebar .list-view .list-row, .fms-sidebar .list-view-group > li .list-row {
  padding: 0;
  margin-bottom: 6px;
  border-radius: 4px;
  box-sizing: border-box;
}
.fms-sidebar .list-view .list-row .hovered, .fms-sidebar .list-view-group > li .list-row .hovered {
  display: none;
}
.fms-sidebar .list-view .list-row:hover, .fms-sidebar .list-view-group > li .list-row:hover {
  cursor: pointer;
}
.fms-sidebar .list-view .list-row:hover .hovered, .fms-sidebar .list-view-group > li .list-row:hover .hovered {
  display: inline-block;
}
.fms-sidebar .list-view .list-row .item label, .fms-sidebar .list-view-group > li .list-row .item label {
  cursor: pointer;
  display: block;
}
.fms-sidebar .list-view .list-row .pull-right, .fms-sidebar .list-view-group > li .list-row .pull-right {
  text-align: right;
  display: flex;
  height: 26px;
  line-height: 26px;
  align-items: center;
}
.fms-sidebar .list-view .list-row .online.action-view, .fms-sidebar .list-view-group > li .list-row .online.action-view {
  color: inherit;
}
.fms-sidebar .list-view .list-row .online.action-view, .fms-sidebar .list-view-group > li .list-row .online.action-view, .fms-sidebar .list-view .list-row:hover .action-view, .fms-sidebar .list-view-group > li .list-row:hover .action-view, .fms-sidebar .list-view .list-row:hover .action-ellipsis, .fms-sidebar .list-view-group > li .list-row:hover .action-ellipsis {
  opacity: 1;
}
.fms-sidebar .list-view .list-row .callout-actions, .fms-sidebar .list-view-group > li .list-row .callout-actions {
  line-height: 26px;
}
.fms-sidebar .list-view .list-row .action-view, .fms-sidebar .list-view-group > li .list-row .action-view,
.fms-sidebar .list-view .list-row .action-ellipsis,
.fms-sidebar .list-view-group > li .list-row .action-ellipsis {
  opacity: 0;
}
@media (max-width: 767px) {
  .fms-sidebar .list-view .list-row .action-view, .fms-sidebar .list-view-group > li .list-row .action-view,
  .fms-sidebar .list-view .list-row .action-ellipsis,
  .fms-sidebar .list-view-group > li .list-row .action-ellipsis {
    opacity: 1;
  }
}
.fms-sidebar .list-view .disabled-row, .fms-sidebar .list-view-group > li .disabled-row {
  opacity: 0.45;
}
.fms-sidebar .list-view a .material-icons, .fms-sidebar .list-view-group > li a .material-icons {
  font-size: 16px;
}
.fms-sidebar .list-view .action-item, .fms-sidebar .list-view-group > li .action-item {
  line-height: 1;
  margin-right: -1px;
}
.fms-sidebar .list-view .action-item .material-icons, .fms-sidebar .list-view-group > li .action-item .material-icons {
  color: inherit;
  vertical-align: middle;
}
.fms-sidebar .list-view .action-item, .fms-sidebar .list-view-group > li .action-item {
  /* &.online {
  	color: \$greenColor;
  } */
}
.fms-sidebar .list-view .action-item .sub-menu, .fms-sidebar .list-view-group > li .action-item .sub-menu {
  min-width: 200px;
}
.fms-sidebar .list-view .action-item.action-ellipsis, .fms-sidebar .list-view-group > li .action-item.action-ellipsis {
  margin-right: 0;
}
.fms-sidebar .list-view .action-clear-list a, .fms-sidebar .list-view-group > li .action-clear-list a {
  cursor: pointer;
}
.fms-sidebar .group-view .list-view-group .list-row {
  padding-left: 5px;
}
.fms-sidebar .group-view .list-view-group .list-row .unit-name {
  font-weight: 400;
}
.fms-sidebar .action-view svg {
  max-width: 18px;
}
.fms-sidebar .action-accuracy svg {
  max-width: 16px;
}
.fms-sidebar .action-connection svg {
  max-width: 16px;
}
.fms-sidebar .action-battery svg {
  max-width: 21;
}
.fms-sidebar .action-additional-menu svg {
  max-width: 14px;
}
.fms-sidebar .action-clear-list svg {
  max-width: 11px;
}
.fms-sidebar .action-ellipsis svg {
  max-width: 6px;
}
.fms-sidebar .list-row-condest .group-view .list-row,
.fms-sidebar .list-row-condest .list-view .list-row,
.fms-sidebar .list-row-condest .list-view-group > li .list-row {
  padding: 0;
  min-height: inherit;
}
.fms-sidebar .list-row-condest .unit-name {
  line-height: 26px;
}
.fms-sidebar .list-view .checkbox input + span, .fms-sidebar .list-view-group > li .checkbox input + span {
  height: 26px;
  display: inline-flex;
  align-items: center;
}
.fms-sidebar .checkbox {
  margin-left: 6px;
}
.fms-sidebar .unit-name {
  max-width: 145px;
  min-width: 145px;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  text-overflow: ellipsis;
  line-height: 26px;
  margin-left: 10px;
  vertical-align: middle;
}
.fms-sidebar .unit-name img {
  max-width: 24px;
  height: auto;
  vertical-align: middle;
  margin-right: 5px;
}
.fms-sidebar .unit-details-box {
  background: #fff;
  padding: 10px;
}
.fms-sidebar .unit-details-box .time-address-row {
  margin-top: 0;
  line-height: 1.7;
}
.fms-sidebar .unit-details-box .statistics-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}
.fms-sidebar .unit-details-box .statistics-table td {
  text-align: center;
  vertical-align: middle;
  padding: 10px;
}
.fms-sidebar .unit-details-box .caption-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}
.fms-sidebar .unit-details-box .caption-table td {
  vertical-align: middle;
  padding: 5px 10px;
}
.fms-sidebar .unit-details-box .caption-table th {
  font-weight: normal;
  padding: 5px 10px;
}

.circle {
  width: 0;
  height: 0;
  border: 8px solid;
  border-radius: 50%;
  display: block;
}

.user-control-nav {
  padding: 0;
  margin: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}
.user-control-nav a {
  color: inherit;
}
.user-control-nav li {
  padding: 5px 10px 4px;
  color: #fff;
  display: inline-block;
}

.sidebar-collapse-button {
  left: 100%;
  top: 62px;
  text-align: center;
  position: absolute;
  padding: 10px 5px 8px;
  border-radius: 0 6px 6px 0;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.15);
}
.sidebar-collapse-button a {
  color: inherit !important;
  display: block;
}
.sidebar-collapse-button svg {
  margin: 0 auto;
}
.sidebar-collapse-button .sidebar-thumbs-icon {
  margin-top: 8px;
}

.sidebar-collapse .sidebar-dragicon {
  display: none;
}

.no-sidebar .main-content-page,
.sidebar-collapse .main-content-page {
  margin-left: 30px;
}
.no-sidebar .fms-sidebar-wrapper,
.sidebar-collapse .fms-sidebar-wrapper {
  margin-left: -285px;
}
.no-sidebar .notification-bar,
.sidebar-collapse .notification-bar {
  left: 50px;
}

@media (max-width: 1279px) {
  .main-content-page {
    margin-left: 10px;
  }
  /* .fms-sidebar-wrapper,
  .fms-sidebar {
  	width: 300px;
  	z-index: 999;
  } */
}`, "",{"version":3,"sources":["webpack://./src/Components/Accounts/accountDetail/Components/index.scss"],"names":[],"mappings":"AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AA6BA;EACE,uBAAA;AAJF;;AAMA;EACE,eAAA;AAHF;;AAOE;EACE,2BAAA;AAJJ;AAME;EACE,yCAAA;AAJJ;AAME;EACE,cAAA;AAJJ;AAKI;EACE,mCAAA;AAHN;AAME;EACE,aAAA;AAJJ;;AAUI;EACE,aAAA;AAPN;AAUE;EACE,mBAAA;AARJ;;AAYA;EACE,iCAAA;AATF;;AAWA;;;;EAIE,wCAAA;AARF;;AAYA;;;;EAAA;AAMA;EACE,0BAAA;EACA,kBAAA;AAVF;;AAYA;;GAAA;AAGA;EACE,eAAA;AATF;;AAWA;EACE,eAAA;AARF;;AAUA;EACE,gBAAA;AAPF;;AASA;EACE,cAAA;AANF;;AAQA;EACE,cAAA;AALF;;AAOA;EACE,iBAAA;EACA,qBAAA;EACA,2CAAA;AAJF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAOA;EAKE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,YAjIU;EAkIV,mBAAA;EACA,0BAAA;AARF;;AAUA;EAME,aAAA;AAZF;;AAiBI;EACE,aAAA;AAdN;AAgBI;EACE,mBAAA;EACA,SAAA;EACA,2HAAA;AAdN;AAmBE;EACE,aAAA;EACA,eAAA;EACA,oBAAA;AAjBJ;AAkBI;EACE,eAAA;EACA,gBAAA;AAhBN;AAmBI;EACE,kBAAA;EACA,YAAA;AAjBN;AAmBM;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AAjBR;AAoBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAlBN;AAoBI;;EAEE,aAAA;AAlBN;AAoBI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAlBN;AAmBM;EACE,iBAAA;EACA,kBAAA;AAjBR;AAsBE;EACE,cAAA;AApBJ;AApCA;EA2DE;;;;KAAA;AAhBF;AAqBE;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAnBJ;AAoBI;EACE,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAlBN;AAoBI;EACE,4BAAA;EACA,mBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,cAAA;AAnBN;AAuBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AArBJ;AAwBE;EACE,cAAA;AAtBJ;AAuBI;EACE,cAAA;AArBN;AAwBE;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAtBJ;AAyBE;;EAEE,kBAAA;EACA,UAAA;EACA,QAAA;AAvBJ;AAyBE;EACE,UAAA;AAvBJ;AAyBE;EACE,QAAA;EACA,kBAAA;EACA,QAAA;AAvBJ;AA0BI;EACE,WAAA;AAxBN;AA0BI;EACE,iBAAA;AAxBN;AAyBM;EACE,kBAAA;AAvBR;AAyBM;EACE,kBAAA;AAvBR;AA4BE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AA1BJ;AA2BI;EACE,WAAA;AAzBN;AA0BM;EACE,WAAA;AAxBR;AA0BM;EACE,WAAA;EACA,gBAAA;AAxBR;AAyBQ;EACE,gBAAA;AAvBV;AA0BQ;EACE,uBAAA;EACA,kBAAA;AAxBV;AA0BQ;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;AAxBV;;AA8BA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;AA3BF;AA6BE;EACE,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAjUQ;AAsSZ;AA6BE;EACE,iBAAA;AA3BJ;AA8BE;EAEE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBA7UQ;AAgTZ;AA8BI;EACE,mBAAA;EACA,eAAA;AA5BN;AA8BI;EACE,oBAAA;AA5BN;AAgCE;EACE,YAxVQ;AA0TZ;AAuCE;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YApWc;EAqWd,kBAAA;AArCJ;AAsCI;EACE,sBAAA;AApCN;AAqCM;EACE,sBAAA;AAnCR;AAuCE;EACE,mBAAA;EACA,SAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AArCJ;;AAyCA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;AAtCF;AA4CE;EACE,iBAAA;EACA,kBAAA;AA1CJ;AA6CE;EACE,YAAA;AA3CJ;AA8CE;EACE,qBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,YAAA;AA7CJ;AAmBA;EA6BE;KAAA;AA5CF;AA+CE;EACE,UAAA;AA7CJ;AA+CE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EAEA,mBAAA;AA9CJ;AAiDM;EACE,oBAAA;AA/CR;AAkDI;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAhDN;AAiDM;EACE,aAAA;AA/CR;AAiDM;EACE,eAAA;AA/CR;AAgDQ;EACE,qBAAA;AA9CV;AAiDM;EACE,eAAA;EACA,cAAA;AA/CR;AAiDM;EACE,iBAAA;EACA,aAAA;EACA,YA9bI;EA+bJ,iBA/bI;EAgcJ,mBAAA;AA/CR;AAiDM;EACE,cAAA;AA/CR;AAiDM;EAGE,UAAA;AAjDR;AAmDM;EACE,iBA3cI;AA0ZZ;AAmDM;;;EAEE,UAAA;AAhDR;AAiDQ;EAHF;;;IAII,UAAA;EA5CR;AACF;AA+CI;EACE,aAAA;AA7CN;AAgDM;EACE,eAAA;AA9CR;AAiDI;EACE,cAAA;EACA,kBAAA;AA/CN;AAgDM;EACE,cAAA;EACA,sBAAA;AA9CR;AAyCI;EAOE;;KAAA;AA3CN;AA2DM;EACE,gBAAA;AAzDR;AA2DM;EACE,eAAA;AAzDR;AA+DM;EACE,eAAA;AA7DR;AAuEI;EACE,iBAAA;AArEN;AAsEM;EACE,gBAAA;AApER;AAyEE;EACE,eAAA;AAvEJ;AAyEE;EACE,eAAA;AAvEJ;AAyEE;EACE,eAAA;AAvEJ;AAyEE;EACE,aAAA;AAvEJ;AAyEE;EACE,eAAA;AAvEJ;AAyEE;EACE,eAAA;AAvEJ;AAyEE;EACE,cAAA;AAvEJ;AA2EI;;;EAEE,UAAA;EACA,mBAAA;AAxEN;AA0EI;EACE,iBA9iBM;AAseZ;AA2EE;EACE,YAljBQ;EAmjBR,oBAAA;EACA,mBAAA;AAzEJ;AA2EE;EACE,gBAAA;AAzEJ;AA4EE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAjkBQ;EAkkBR,iBAAA;EACA,sBAAA;AA1EJ;AA2EI;EACE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;AAzEN;AA6EE;EACE,gBAAA;EACA,aAAA;AA3EJ;AA6EI;EACE,aAAA;EACA,gBAAA;AA3EN;AA6EI;EACE,WAAA;EACA,yBAAA;EAEA,mBAAA;AA5EN;AA6EM;EACE,kBAAA;EAEA,sBAAA;EACA,aAAA;AA5ER;AA+EI;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AA7EN;AA8EM;EAEE,sBAAA;EACA,iBAAA;AA7ER;AA+EM;EAGE,mBAAA;EACA,iBAAA;AA/ER;;AAqFA;EACE,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAlFF;;AAqFA;EACE,UAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;AAlFF;AAoFE;EACE,cAAA;AAlFJ;AAoFE;EACE,qBAAA;EACA,WAAA;EACA,qBAAA;AAlFJ;;AAuFA;EACE,UAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,0BAAA;EACA,2CAAA;AApFF;AAqFE;EACE,yBAAA;EACA,cAAA;AAnFJ;AAqFE;EACE,cAAA;AAnFJ;AAqFE;EACE,eAAA;AAnFJ;;AAwFE;EACE,aAAA;AArFJ;;AA0FE;;EACE,iBAAA;AAtFJ;AAwFE;;EACE,mBAAA;AArFJ;AA0FE;;EACE,UAAA;AAvFJ;;AAmGA;EACE;IACE,iBAAA;EAhGF;EAkGA;;;;KAAA;AA5FF","sourcesContent":["@import \"./../../../../assets/variables\"; \n$rowHeight: 26px;\n$rowParentHeight: 32px;\n\n/* .sidebar-collapse-button {\n\tright: 5px;\n\ttop: 0;\n\ttext-align: center;\n\tposition: absolute;\n\tpadding: 0;\n\tz-index: 9999;\n\tborder-radius: 0;\n\twidth: 20px;\n\theight: 15px;\n\t\n\ta {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tposition: absolute;\n\t\tborder-radius: 24px;\n\t\tcolor: inherit !important;\n\t\ttop: 50%;\n\t\tmargin-top: -12px;\n\t\tright: -12px;\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t}\n\tsvg {\n\t\tmargin: 0 auto;\n\t\tdisplay: block;\n\t}\n} */\n\n.sidebar-dragicon {\n  cursor: move !important;\n}\n.sidebar-thumbs-icon {\n  font-size: 14px;\n}\n\n.trackYVisible {\n  .ScrollbarsCustom-TrackY {\n    background: none !important;\n  }\n  .ScrollbarsCustom-ThumbY {\n    background: rgba(0, 0, 0, 0.5) !important;\n  }\n  &:hover .ScrollbarsCustom-ThumbY {\n    display: block;\n    &:hover {\n      background: rgba(0, 0, 0, 1) !important;\n    }\n  }\n  .ScrollbarsCustom-ThumbY {\n    display: none;\n  }\n}\n\n.main-navigation {\n  .trackYVisible, .trackXVisible {\n    .ScrollbarsCustom-Track {\n      display: none;\n    }\n  }\n  .ScrollbarsCustom-Wrapper {\n    inset: 0 !important;\n  }\n}\n\n.sidebar-devices-list {\n  height: calc(100vh - $headerHeight - $footerHeight);\n}\n.geofence-sidebar-list,\n.sidebar-drivers-list,\n.sidebar-users-list,\n.sidebar-devices-list.with-tabs {\n  height: calc(100vh - 66px - 54px - 60px);\n}\n//.sidebar-drivers-list,\n//.sidebar-devices-list,\n/* .calendar-sidebar-list {\n\toverflow: hidden;\n\toverflow-y: scroll;\n}\n */\n\n.notification-scroller {\n  height: calc(100vh - 10px);\n  overflow-y: scroll;\n}\n/* .scrollable-sidebar {\n\theight: calc(100vh );\n} */\n.action-item.online {\n  color: '#fffff';\n}\n.action-item.offline {\n  color: '#fff45';\n}\n.action-item.unknown {\n  color: '#f8989f';\n}\n.action-item.not-updated {\n  color: #0288d1;\n}\n.action-item.not-registered {\n  color: #d7d7d7;\n}\n.main-content-page {\n  margin-left: 60px;\n  transition:  0.3s ease;\n  box-shadow: 0 0 3px 1px rgba(#000, 0.15);\n}\n.left-nav {\n  transition:  0.3s ease;\n}\n\n.sidebar-bg-layer {\n  border-radius: 6px;\n  //overflow: hidden;\n}\n\n.fms-sidebar\n  .list-row-condest\n  .list-view-group\n  > li\n  > .list-row:first-child:before {\n  content: '';\n  display: inline-block;\n  width: 6px;\n  height: $rowHeight;\n  vertical-align: top;\n  border-radius: 0 5px 5px 0;\n}\n.main-list-view\n  .fms-sidebar\n  .list-row-condest\n  .list-view-group\n  > li\n  > .list-row:first-child:before {\n  display: none;\n}\n\n.main-thumb-view .fms-sidebar {\n  .list-view-children {\n    .v-checkbox.on-inactive {\n      display: none;\n    }\n    .v-checkbox.on-active {\n      border-radius: 50px;\n      border: 0;\n      box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n        0px 6px 10px 0px rgba(0, 0, 0, 0.14),\n        0px 1px 18px 0px rgba(0, 0, 0, 0.12);\n    }\n  }\n  .list-view {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 10px 10px 0;\n    .list-view {\n      padding-left: 0;\n      padding-right: 0;\n    }\n    //margin-left: -6px;\n    .list-row {\n      border-radius: 6px;\n      height: 100%;\n\n      .pull-right {\n        float: none !important;\n        text-align: center;\n        line-height: 16px;\n        height: 16px;\n      }\n    }\n    .checkbox {\n      position: absolute;\n      right: -2px;\n      bottom: -4px;\n      z-index: 9;\n    }\n    .action-item,\n    .action-item.action-running {\n      margin-top: 0;\n    }\n    .action-connection {\n      float: none;\n      margin-left: auto;\n      margin-right: auto;\n      text-align: center;\n      .circle {\n        margin-left: auto;\n        margin-right: auto;\n      }\n    }\n  }\n\n  .action-running.online {\n    color: inherit;\n  }\n\n  /* .list-row-condest .list-view .action-item,\n\t.list-row-condest .list-view-group > li .action-item,\n\t.list-row-condest .list-view-group > li .action-item {\n\t\tline-height: 10px;\n\t} */\n  .list-view > li {\n    display: inline-block;\n    width: 93px;\n    position: relative;\n    padding-left: 4px;\n    padding-bottom: 4px;\n    flex: 0 0 33.3333%;\n    .list-action-bar {\n      height: auto;\n      display: block;\n      padding-top: 0;\n      line-height: 4px;\n    }\n    .unit-name {\n      min-width: calc(100% - 20px);\n      margin: 15px 10px 0;\n\n      max-width: inherit;\n      text-align: center;\n      display: block;\n    }\n  }\n\n  .unit-name img {\n    width: 42px;\n    height: 42px;\n    max-width: none;\n    display: block;\n    margin: 0 auto;\n  }\n\n  .action-connection {\n    display: block;\n    a {\n      display: block;\n    }\n  }\n  .circle {\n    width: 46px;\n    border-radius: 0;\n    border-width: 1.5px;\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n\n  .action-running,\n  .action-view {\n    position: absolute;\n    left: 32px;\n    top: 5px;\n  }\n  .action-running {\n    left: 10px;\n  }\n  .action-ellipsis {\n    right: 0;\n    position: absolute;\n    top: 5px;\n  }\n  .group-view {\n    .list-view {\n      width: 100%;\n    }\n    .list-view-group > li .list-view .list-row {\n      padding-left: 5px;\n      .unit-name {\n        min-width: inherit;\n      }\n      .pull-right {\n        text-align: center;\n      }\n    }\n  }\n\n  .list-view-group {\n    display: flex;\n    flex-direction: column;\n    font-size: 12px;\n    > li {\n      width: 100%;\n      > div {\n        width: 100%;\n      }\n      > .list-row:first-child {\n        width: 100%;\n        border-radius: 0;\n        > .checkbox {\n          position: static;\n        }\n\n        .pull-right {\n          float: right !important;\n          text-align: center;\n        }\n        .unit-name {\n          display: inline-block;\n          text-align: left;\n          margin: 0 0 0 10px;\n        }\n      }\n    }\n  }\n}\n.filter-row {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  display: table;\n  width: 100%;\n\n  > li {\n    display: table-cell;\n    vertical-align: middle;\n    white-space: nowrap;\n    padding: 0 6px;\n    line-height: $rowHeight;\n  }\n  .btn-group {\n    margin-left: 10px;\n  }\n\n  > li > a {\n    // font-size: $baseIconFontSize;\n    padding-left: 2px;\n    padding-right: 2px;\n    color: inherit;\n    vertical-align: bottom;\n    line-height: $rowHeight;\n    svg {\n      vertical-align: top;\n      margin-top: 3px;\n    }\n    i {\n      line-height: inherit;\n    }\n  }\n\n  .checkbox input + span {\n    height: $rowHeight;\n  }\n  .active a {\n    // color: $themeColor;\n  }\n  .action-clear-list {\n    // color: $redColor;\n  }\n\n  .filter-nav {\n    font-size: 12px;\n    display: table;\n    width: 100%;\n    height: $rowParentHeight;\n    position: relative;\n    .add-group-link {\n      vertical-align: middle;\n      i {\n        vertical-align: middle;\n      }\n    }\n  }\n  .filter-nav-link {\n    display: table-cell;\n    width: 1%;\n    border-radius: 6px 6px 0 0;\n    vertical-align: middle;\n    font-size: inherit;\n    text-decoration: none;\n    font-weight: bold;\n    text-align: center;\n  }\n}\n\n.fms-sidebar {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  .fms-sidebar-monitoring .sidebar-bg-layer,\n  &.sidebar-bg-layer {\n    // box-shadow: 0 0 3px 1px rgba(#000000, 0.15);\n  }\n\n  .section-head {\n    padding: 5px 10px;\n    margin-bottom: 3px;\n  }\n\n  .section-head-filter {\n    padding: 5px;\n  }\n\n  .v-divider {\n    display: inline-block;\n    vertical-align: top;\n    // border-left: 1px solid darken($sidebarRowBg, 8%);\n    margin-left: 8px;\n    margin-right: 8px;\n    height: 21px;\n  }\n\n  /* .individual-view {\n\t} */\n\n  .group-view .list-view-children {\n    padding: 0;\n  }\n  .list-view {\n    margin: 0;\n    padding: 0 10px;\n    list-style: none;\n    // font-size: $baseFontSize;\n    font-weight: normal;\n\n    .checkbox input + span {\n      i {\n        line-height: inherit;\n      }\n    }\n    .list-row {\n      padding: 0;\n      margin-bottom: 6px;\n      border-radius: 4px;\n      box-sizing: border-box;\n      .hovered {\n        display: none;\n      }\n      &:hover {\n        cursor: pointer;\n        .hovered {\n          display: inline-block;\n        }\n      }\n      .item label {\n        cursor: pointer;\n        display: block;\n      }\n      .pull-right {\n        text-align: right;\n        display: flex;\n        height: $rowHeight;\n        line-height: $rowHeight;\n        align-items: center;\n      }\n      .online.action-view {\n        color: inherit;\n      }\n      .online.action-view,\n      &:hover .action-view,\n      &:hover .action-ellipsis {\n        opacity: 1;\n      }\n      .callout-actions {\n        line-height: $rowHeight;\n      }\n      .action-view,\n      .action-ellipsis {\n        opacity: 0;\n        @media (max-width: 767px) {\n          opacity: 1;\n        }\n      }\n    }\n    .disabled-row {\n      opacity: 0.45;\n    }\n    a {\n      .material-icons {\n        font-size: 16px;\n      }\n    }\n    .action-item {\n      line-height: 1;\n      margin-right: -1px;\n      .material-icons {\n        color: inherit;\n        vertical-align: middle;\n      }\n      /* &.online {\n\t\t\t\tcolor: $greenColor;\n\t\t\t} */\n      &.stop {\n        // color: $redColor;\n      }\n      &.offline {\n        // color: $red;\n      }\n      &.unknown,\n      &.away {\n        // color: $yellowColor;\n      }\n      .circle {\n        //margin-top: -0.2em;\n      }\n      .sub-menu {\n        min-width: 200px;\n      }\n      &.action-ellipsis {\n        margin-right: 0;\n      }\n    }\n\n    .action-clear-list {\n      //   color: $redColor;\n      a {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .list-view-group > li {\n    @extend .list-view;\n  }\n\n  .group-view {\n    .list-view-group .list-row {\n      padding-left: 5px;\n      .unit-name {\n        font-weight: 400;\n      }\n    }\n  }\n\n  .action-view svg {\n    max-width: 18px;\n  }\n  .action-accuracy svg {\n    max-width: 16px;\n  }\n  .action-connection svg {\n    max-width: 16px;\n  }\n  .action-battery svg {\n    max-width: 21;\n  }\n  .action-additional-menu svg {\n    max-width: 14px;\n  }\n  .action-clear-list svg {\n    max-width: 11px;\n  }\n  .action-ellipsis svg {\n    max-width: 6px;\n  }\n\n  .list-row-condest {\n    .group-view .list-row,\n    .list-view .list-row {\n      padding: 0;\n      min-height: inherit;\n    }\n    .unit-name {\n      line-height: $rowHeight;\n    }\n  }\n  .list-view .checkbox input + span {\n    height: $rowHeight;\n    display: inline-flex;\n    align-items: center;\n  }\n  .checkbox {\n    margin-left: 6px;\n  }\n\n  .unit-name {\n    max-width: 145px;\n    min-width: 145px;\n    overflow: hidden;\n    white-space: nowrap;\n    display: inline-block;\n    text-overflow: ellipsis;\n    line-height: $rowHeight;\n    margin-left: 10px;\n    vertical-align: middle;\n    img {\n      max-width: 24px;\n      height: auto;\n      vertical-align: middle;\n      margin-right: 5px;\n    }\n  }\n\n  .unit-details-box {\n    background: #fff;\n    padding: 10px;\n    // border-bottom: 1px solid $borderColor;\n    .time-address-row {\n      margin-top: 0;\n      line-height: 1.7;\n    }\n    .statistics-table {\n      width: 100%;\n      border-collapse: collapse;\n      //   font-size: $baseFontSize + 2;\n      margin-bottom: 10px;\n      td {\n        text-align: center;\n        // border: 1px solid $borderColor;\n        vertical-align: middle;\n        padding: 10px;\n      }\n    }\n    .caption-table {\n      width: 100%;\n      border-collapse: collapse;\n      margin-bottom: 10px;\n      td {\n        // border: 1px solid $borderColor;\n        vertical-align: middle;\n        padding: 5px 10px;\n      }\n      th {\n        // border: 1px solid $borderColor;\n        // background: $sidebarBackground;\n        font-weight: normal;\n        padding: 5px 10px;\n      }\n    }\n  }\n}\n\n.circle {\n  width: 0;\n  height: 0;\n  border: 8px solid;\n  border-radius: 50%;\n  display: block;\n}\n\n.user-control-nav {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  text-align: center;\n  //   background: $themeColor;\n  a {\n    color: inherit;\n  }\n  li {\n    padding: 5px 10px 4px;\n    color: #fff;\n    display: inline-block;\n  }\n}\n\n//--collapse\n.sidebar-collapse-button {\n  left: 100%;\n  top: 62px;\n  text-align: center;\n  position: absolute;\n  padding: 10px 5px 8px;\n  border-radius: 0 6px 6px 0;\n  box-shadow: 0 0 3px 1px rgba(#000000, 0.15);\n  a {\n    color: inherit !important;\n    display: block;\n  }\n  svg {\n    margin: 0 auto;\n  }\n  .sidebar-thumbs-icon {\n    margin-top: 8px;\n  }\n}\n\n.sidebar-collapse {\n  .sidebar-dragicon {\n    display: none;\n  }\n}\n.no-sidebar,\n.sidebar-collapse {\n  .main-content-page {\n    margin-left: 30px;\n  }\n  .fms-sidebar-wrapper {\n    margin-left: -$sidebarWidth;\n  }\n  .main-view {\n    // left: $headerHeight;\n  }\n  .notification-bar {\n    left: 50px;\n  }\n}\n\n.header-open {\n  .main-view {\n    // left: $headerNavWidth;\n  }\n}\n\n// responsive\n\n@media (max-width: 1279px) {\n  .main-content-page {\n    margin-left: 10px;\n  }\n  /* .fms-sidebar-wrapper,\n\t.fms-sidebar {\n\t\twidth: 300px;\n\t\tz-index: 999;\n\t} */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
